module.exports = __webpack_public_path__ + "img/gobi-full-logo.74c67f2c.svg";